export const iconFontAwesomeUsersPeoplePersonRifle = (
	<i className="fa-solid fa-person-rifle"></i>
);
